import { reactive } from 'vue';

export const criarEpMenuDoc = () => {
    return reactive({
        id: 0,
        idep: 0,
        titulo: '',
        icone: '',
        ordem: 0,
        idlogin: 0,
    });
}
